import { useQuery } from "@tanstack/react-query";
import { getCurrenciesForSelect } from "../../api/apiCurrencies";
import { useTranslation } from "react-i18next";

const useGetCurrenciesForSelect = (filters = {}) => {
    const { i18n } = useTranslation();

    const {
        data,
        isLoading,
        error,
        refetch,
        isFetching,
    } = useQuery({
        queryKey: ["currencies-for-select", filters],
        queryFn: () => getCurrenciesForSelect(filters),
        staleTime: 5 * 60 * 1000, // 5 minutes
    });

    const currenciesList = Array.isArray(data) ? data : (data?.data || []);

    const options = currenciesList.map(currency => ({
        value: currency.id,
        label: `${currency.name?.[i18n.language] || currency.name?.en || currency.code} (${currency.symbol})`
    }));

    return {
        options,
        rawData: data,
        isLoading,
        error,
        refetch,
        isFetching,
    };
};

export default useGetCurrenciesForSelect;
